export const JWT_TOKEN_LOCAL = "jwtToken";
export const REFRESH_TOKEN_LOCAL = "refreshToken";
export const USERNAME = "username";
export const AVATAR = "avatar";
export const PHONE_REGREX = new RegExp(
  "^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$"
);

export const WATERMARK_API_URL =
  process.env.REACT_APP_APP_ENV === "production"
    ? "https://watermark.crooklynclan.net"
    : "https://3.146.154.224:4007";
